import { useTranslation } from "react-i18next";
import { MapPin, Briefcase } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface OpportunityDetailsProps {
  description: string;
  location: string | null;
  compensation: string | null;
  remoteAllowed: boolean;
  requirements: string | null;
  lookingFor?: string[] | null;
}

export const OpportunityDetails = ({
  description,
  location,
  compensation,
  remoteAllowed,
  requirements,
  lookingFor
}: OpportunityDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-4">
      <p className="text-sm text-muted-foreground mb-4">{description}</p>
      <div className="flex flex-wrap gap-4 text-sm text-muted-foreground">
        {location && (
          <div className="flex items-center">
            <MapPin className="w-4 h-4 mr-1" />
            {location}
          </div>
        )}
        {compensation && (
          <div className="flex items-center">
            <Briefcase className="w-4 h-4 mr-1" />
            {compensation}
          </div>
        )}
        {remoteAllowed && (
          <Badge variant="outline">
            {t('opportunityCard.remoteAvailable')}
          </Badge>
        )}
      </div>
      {lookingFor && lookingFor.length > 0 && (
        <div className="mt-4">
          <h4 className="font-semibold mb-2">{t('opportunityCard.lookingFor')}:</h4>
          <div className="flex flex-wrap gap-2">
            {lookingFor.map((role, index) => (
              <Badge key={index} variant="secondary">
                {role}
              </Badge>
            ))}
          </div>
        </div>
      )}
      {requirements && (
        <div className="mt-4">
          <h4 className="font-semibold mb-2">{t('opportunityCard.requirements')}:</h4>
          <p className="text-sm text-muted-foreground">{requirements}</p>
        </div>
      )}
    </div>
  );
};